export default [
  {
    id: 'wein-wissen',
    title: 'Wein&Wissen',
    slogan: 'Weinverkostung und Seminar bei traditionsreichen Weingütern',
    shortDescription: 'Lernen Sie alles über Wein und werden Sie Experte',
    primaryColor: '#d9374a',
    secondaryColor: '#181615',
    previewImage: require('./assets/img/wein-wissen.jpg'),
    image: require('./assets/img/wein-wissen-desktop.jpg'),
    smallImage: require('./assets/img/wein-wissen-mobil.jpg'),
    arrivalInfo: `Nach Ihrer individuellen Anreise und dem Check-In im Gästehaus Spinne in Neustadt-Haardt a.d.W.
    am Freitagabend können wir uns bei einem gemeinsamen Abendessen im Hotel kennenlernen und
    uns auf das bevorstehende AUSZEIT-Wochenende einstimmen.`,
    experienceInfo: `Gut gestärkt nach einem reichhaltigen Frühstück starten wir unser AUSZEIT Erlebnis. Zu Fuß
    erreichen wir bequem das VDP-WEINGUT MÜLLER-CATOIR. Am Rande des Pfälzer Waldes ragt, von
    weitem sichtbar, das Haardter Schloss empor. Ihm zu Füßen liegt im Ortskern von Haardt das
    beeindruckende Gutsgebäude von Müller-Catoir. Seit 1744 in Familienbesitz werden hier erstklassige
    Bio-Weine gekeltert. Hier erwartet uns eine Guts- und Kellerführung mit anschließender Verkostung.
    Danach geht’s zu Fuß weiter zum neu gestalteten WEINGUT VON OLIVER ZETER, einer der innovativsten
    Winzer der Pfalz; ein Visionär mit Leib und Seele. Hier kommen wir in den Genuss einer
    besprochenen Weinprobe mit Kellerführung. Dabei erfahren wir Wissenswertes zur Arbeit in
    Weinberg und -keller und dürfen auch gleich die Ergebnisse verkosten. Eine typisch pfälzische
    Winzervesper darf hier natürlich nicht fehlen…
    Danach lassen wir uns ins nahe Deidesheim fahren, wo Sie in einem renommierten VDP-WEINGUT
    Ihr Weinwissen in einem intensiven, dennoch kurzweiligen Seminar vertiefen.
    Am Ende dieses beeindruckenden Tages kehren wir zu unserem AUSZEIT-Domizil zurück, wo wir ein
    leckeres Abendessen zu uns nehmen und die Eindrücke des Tages nachwirken lassen.`,
    departureInfo: `Am Sonntagmorgen steht wieder ein leckeres Frühstück für Sie bereit. Danach treten Sie in Ruhe und
    entspannt Ihre individuelle Heimreise an.`,
    location: 'Neustadt',
    price: 479,
    singleRoomAdditional: 30,
    coordinates: [8.142530, 49.371710],
    services: [
      'Begrüßungssekt',
      '2 Übernachtungen im Gasthaus Spinne, Neustadt a.d.W. (oder gleichwertig)',
      '2 x Frühstück',
      '2 x Abendmenü in der Spinne',
      '1 x Weingutsbesuch incl. Weinprobe und Kellerführung bei Müller-Catoir',
      '1 x Weingutsbesuch incl. Weinprobe, Kellerführung und Winzervesper bei Oliver Zeter',
      '1 x Basis-Seminar bei Reichsrat von Buhl (VDP)',
      'Transferfahrten',
      'Durchgängige AUSZEIT-Reiseleitung'
    ]
  },
  {
    id: 'wein-wellness',
    title: 'Wein&Wellness',
    slogan: 'Die perfekte Auszeit für Ihren Körper und Geist',
    shortDescription: 'Gönnen Sie Körper und Geist eine Pause vom Alltag',
    primaryColor: '#f8b020',
    secondaryColor: '#85472c',
    previewImage: require('./assets/img/wein-wellness.jpg'),
    image: require('./assets/img/wein-wellness-desktop.jpg'),
    smallImage: require('./assets/img/wein-wellness-mobil.jpg'),
    arrivalInfo: `Nach Ihrer individuellen Anreise und dem Check-In im exklusiven Kaisergarten Hotel&SPA in
    Deidesheim am Freitagabend können wir uns bei einem gemeinsamen Mehrgänge-Menü im Hotel
    kennenlernen und uns auf das bevorstehende AUSZEIT-Wochenende einstimmen.`,
    experienceInfo: `Gut gestärkt nach einem reichhaltigen Frühstück in unserem Luxushotel starten wir unser AUSZEIT
    Erlebnis. Nach 2-minütigem Fußmarsch erreichen wir die „VILLA IM PARADIES“ – der Name ist
    Programm! Hier erwartet uns eine spannend-unterhaltsame Weinprobe incl. Weinbergs- und
    Kellerführung mit anschließendem Picknick im Park des Anwesens, bei schlechtem Wetter im nicht
    minder beeindruckenden Gewölbekeller.
    Bereits in vierter Generation lebt Familie Menger-Krug auf dem Weingut. Marie Menger-Krug
    präsentiert ihre eigene Wein- und Sektkollektion Motzenbäcker. Jeder Wein und Sekt ist biologisch
    an- und ausgebaut.
    Beschwingt kehren wir zu Fuß in unser Hotel zurück. Dort angekommen können Sie sich durch das
    vielfältige WELLNESS-ANGEBOT verwöhnen lassen. Gönnen Sie Körper und Geist eine Pause vom Alltag…
    Beim anschließenden gemeinsamen Abendessen im Hotel lassen wir die Eindrücke des Tages auf uns
    wirken.`,
    departureInfo: `Am Sonntagmorgen steht wieder ein leckeres Frühstück für Sie bereit. Um unser Wein&Wellness-
    Erlebnis abzurunden fahren wir ins nahe gelegene Bad Dürkheim, zum VDP-Weingut Fitz-Ritter. Das
    Familienunternehmen wird heute in neunter Generation von Johann Fitz und seiner Frau geführt und
    vereint Bio-Weingut mit der ältesten Sektkellerei in Rheinland-Pfalz. Bei Entspannungs- und
    Atemübungen unter professioneller Anleitung, inmitten des prämierten Gutsparks, finden Sie innere
    Ruhe und Ausgeglichenheit. So entspannt und gestärkt mit heißen Flammkuchen treten Sie Ihre
    individuelle Heimreise an.`,
    location: 'Deidesheim',
    price: 499,
    singleRoomAdditional: 30,
    coordinates: [8.186470, 49.410120],
    services: [
      'Begrüßungssekt',
      '2 Übernachtungen im Doppelzimmer Luxushotel Kaisergarten, Deidesheim (oder gleichwertig)',
      '2 x Frühstücksbuffet',
      '2 x Abendmenü im Hotel',
      '1 x Weingutsführung incl. Weinprobe und Picknick „Villa im Paradies“',
      'Nutzung des Wellness- und Fitnessbereichs im Kaisergarten Hotel&SPA',
      '1 x Gutschein über Fußmassage oder gleichwertig',
      'Durchgängige AUSZEIT-Reiseleitung'
    ]
  },
  {
    id: 'wein-kultur',
    title: 'Wein&Kultur',
    slogan: 'Genießen Sie Weltklasse — Beim Wein und bei der Kultur',
    shortDescription: 'Von den Weinbergen in die Semperoper',
    primaryColor: '#5537d9',
    secondaryColor: '#806b86',
    previewImage: require('./assets/img/wein-kultur.jpg'),
    image: require('./assets/img/wein-kultur-desktop.jpg'),
    smallImage: require('./assets/img/wein-kultur-mobil.jpg'),
    arrivalInfo: `Nach Ihrer individuellen Anreise und dem Check-In im Indigo-Hotel in der Dresdner Innenstadt am
    Freitagabend können wir uns bei einem gemeinsamen Abendessen in einem nahe gelegenen
    Restaurant kennenlernen und uns auf das bevorstehende AUSZEIT-Wochenende einstimmen.`,
    experienceInfo: `Gut gestärkt nach einem reichhaltigen Frühstück im Hotel starten wir unser AUSZEIT Erlebnis.
    Entspannt lassen wir uns nach Pillnitz fahren. Im VDP-WEINGUT KLAUS ZIMMERLING erwartet uns eine
    besprochene Weinprobe mit Weinbergs- und Kellerführung. Neben den Weinen werden Sie auch von
    der Kunst im Weingut begeistert sein… Ein 5-minütiger Fußmarsch durch die Weinberge führt uns
    zum SCHLOSSHOTEL PILLNITZ, wo wir unser Mittagessen einnehmen und die Atmosphäre auf uns wirken
    lassen. Von der nahe gelegenen Anlegestelle Pillnitz aus starten wir unsere SCHIFFFAHRT zurück nach
    Dresden. Dort angekommen genießen Sie etwas Zeit zur freien Verfügung, in der Sie nach Belieben
    Sehenswürdigkeiten der historischen Altstadt besichtigen, durch die Shopping Mall schlendern oder
    in einem der vielen Straßencafés verweilen können. Der krönende Abschluss des AUSZEITerlebnisses
    wird die Aufführung der Oper „Il barbiere di Siviglia“ von Gioachino Rossini in der weltberühmten
    SEMPER-OPER sein.`,
    departureInfo: `Am Sonntagmorgen steht wieder ein leckeres Frühstück für Sie bereit. Danach treten Sie in Ruhe und
    entspannt Ihre individuelle Heimreise an.`,
    location: 'Dresden',
    price: 499,
    singleRoomAdditional: 30,
    coordinates: [13.723670, 51.054070],
    services: [
      'Begrüßungssekt',
      '2 Übernachtungen im Doppelzimmer im Indigo-Hotel in Dresden (oder gleichwertig)',
      '2 x Frühstücksbuffet',
      '1 x Abendmenü in einem Restaurant der Dresdener Innenstadt',
      '1 x Mittagsmenü im Schlosshotel Pillnitz',
      '1 x Elbe-Schifffahrt',
      '1 x Weingutsbesuch incl. Kellerführung bei Weingut Zimmerling, Pillnitz',
      '1 x Opernbesuch',
      'Durchgängige AUSZEIT-Reiseleitung'
    ]
  },
  {
    id: 'wein-natur',
    title: 'Wein&Natur',
    slogan: 'Erleben Sie den Zauber des Frühlings',
    shortDescription: 'Erleben Sie den Zauber des Frühlings',
    primaryColor: '#c5cd43',
    secondaryColor: '#2E3427',
    previewImage: require('./assets/img/wein-natur.jpg'),
    image: require('./assets/img/wein-natur-desktop.jpg'),
    smallImage: require('./assets/img/wein-natur-mobil.jpg'),
    arrivalInfo: `Nach Ihrer individuellen Anreise und dem Check-In im Weingut und Landhotel Lucashof in Forst
    a.d.Weinstraße am Freitagabend können wir uns bei einem gemeinsamen Abendessen im fußläufig
    gelegenen Restaurant „Ungeheuer“ kennenlernen und uns auf das bevorstehende AUSZEIT-
    Wochenende einstimmen.`,
    experienceInfo: `Gut gestärkt nach einem reichhaltigen Frühstück in unserem gemütlichen Hotel starten wir unser
    AUSZEIT Erlebnis. Entspannt lassen wir uns ins nahe gelegene Deidesheim fahren. Von dort starten
    wir eine SEGWAY-TOUR durch die Deidesheimer Weinberge mit herrlicher Sicht auf die Rhein-Ebene
    und urige Winzerdörfer. Endpunkt der Tour ist das VDP-WEINGUT VON WINNING. Seit der Gründung des
    Weinguts im Jahr 1849 reifen Spitzenweine aus einzigartigen Weinbergen der Pfalz in den
    historischen Kellern. Bei einer besprochenen Weinprobe dürfen wir einige davon verkosten.
    Nach einer kurzen Fahrt ins benachbarte Bad Dürkheim und einer kleinen Vesper starten wir zu einer ca. 2 1/2-stündigen
    geführten WEINWANDERUNG. Das Frühlingserwachen in der Pfalz ist rosa-rot, wenn die
    Mandeln blühen. Passend zu dieser Szenerie probieren wir herzhafte und süße typische pfälzische Genusskreationen
    mit abgestimmten Weinen Dürkheimer Weingüter. Auf der Tour hören Sie außerdem
    Wissenswertes und Kurioses über die Pfalz und ihre Weine.
    Nach so viel frischer Luft, Bewegung und Natur pur lassen wir uns zurück in unser gemütliches Hotel
    fahren, wo wir Gelegenheit haben, die Eindrücke des heutigen Tages auf uns wirken zu lassen. Beim
    anschließenden gemeinsamen Abendessen in Forst lassen wir den Tag genussvoll ausklingen.`,
    departureInfo: `Am Sonntagmorgen steht wieder ein leckeres Frühstück für Sie bereit. Danach treten Sie in Ruhe und
    entspannt Ihre individuelle Heimreise an.`,
    location: 'Forst',
    price: 479,
    singleRoomAdditional: 30,
    coordinates: [8.584460, 49.150489],
    services: [
      'Begrüßungssekt',
      '2 Übernachtungen im Doppelzimmer Landhotel Lucashof, Forst a.d.W. (oder gleichwertig)',
      '2 x Frühstücksbuffet',
      '2 x Abendmenü in Forst',
      '1 x Segway-Tour',
      '1 x Weingutsbesuch incl. Kellerführung und Weinprobe bei VON WINNING (VDP)',
      '1 x Frühlings-Genusstour incl. Mandelspezialitäten und Dürkheimer Weine',
      '1 x Weingutsbesuch incl. Entspannungsübungen und Flammkuchen bei Fitz-Ritter (VDP)',
      'Transferfahrten',
      'Durchgängige AUSZEIT-Reiseleitung'
    ]
  },
  {
    id: 'wein-nachhaltigkeit',
    title: 'Wein&Nachhaltigkeit',
    slogan: 'Pflanzen Sie Ihren Rebstock in einem Bio-Weingut',
    shortDescription: 'Pflanzen Sie eine Rebe in einem Bio-Weingut',
    primaryColor: '#3787d9',
    secondaryColor: '#384961',
    previewImage: require('./assets/img/wein-nachhaltigkeit.jpg'),
    image: require('./assets/img/wein-nachhaltigkeit-desktop.jpg'),
    smallImage: require('./assets/img/wein-nachhaltigkeit-mobil.jpg'),
    arrivalInfo: `Nach Ihrer individuellen Anreise und dem Check-In im Hotel-Café Ritter von Böhl in Deidesheim, das
    seit Oktober 2018 als umwelt- und klimafreundliches Hotel zertifiziert ist, können wir uns bei einem
    gemeinsamen Abendessen im fußläufig erreichbaren Leopold’s (Weingut Von Winning) bei
    regionalen Spezialitäten kennenlernen und uns auf das bevorstehende AUSZEIT-Wochenende
    einstimmen.`,
    experienceInfo: `Gut gestärkt nach einem reichhaltigen Frühstück in unserem gemütlichen Hotel starten wir unser
    AUSZEIT Erlebnis. Entspannt lassen wir uns nach Bad Dürkheim, zum VDP- UND BIO WEINGUT FITZ-
    RITTER, fahren. Das Familienunternehmen wird heute in neunter Generation von Johann Fitz geführt
    und vereint Bio-Weingut mit der ältesten Sektkellerei in Rheinland-Pfalz. Nach der Begrüßung im
    prämierten Gutspark „Schönster Garten an der deutschen Weinstraße“ erleben wir eine
    außergewöhnliche Gutsführung. Im Hausweinberg werden uns die wichtigsten Arbeiten im
    ökologischen Weinbau nähergebracht und im 230 Jahre alten Sandstein-Gewölbekeller erfahren wir
    mehr über die Wein- bzw. Sektherstellung. Es folgt eine 6-teilige besprochene Weinprobe plus 2
    Sorten Sekt und Bauernbrot. Als Höhepunkt des heutigen Tages: die eigene Bio-Rebe auf dem
    Weingut, die Sie 3 Jahre mit Wein versorgt. Sie erhalten Ihr persönliches Pächter-Zertifikat und
    können „Ihrem“ Rebstock, an dem ein graviertes Namensschild angebracht ist, so oft Sie wollen
    einen Besuch abstatten.
    Auf der Rückfahrt zum Hotel machen wir noch einen Abstecher bei den TEE-GÄRTNERN „SCHÖNFELD“ in
    Ruppertsberg. Treu ihrem Motto „Made with Love in Germany“ bauen Jessica Schönfeld und
    Christian Weiß ihre Teesorten und sonstige Zutaten selbst an, ernten und verarbeiten sie. Bei einer
    Hofführung erfahren wir noch mehr über ihre Arbeit und dürfen selbstverständlich auch einige Tees
    verkosten. Bei einem gemeinsamen Abendessen im BIO-HOFGUT RUPPERTSBERG lassen wir den Tag
    ausklingen und die Eindrücke nachwirken. Nach einem kurzen Verdauungsspaziergang kommen wir
    am Ende eines interessanten Tages wieder in unserem Hotel an.`,
    departureInfo: `Am Sonntagmorgen steht wieder ein leckeres Frühstück für Sie bereit. Danach treten Sie in Ruhe und
    entspannt Ihre individuelle Heimreise an.`,
    location: 'Deidesheim',
    price: 469,
    singleRoomAdditional: 30,
    coordinates: [8.187290, 49.407480],
    services: [
      'Begrüßungssekt',
      '2 Übernachtungen im Doppelzimmer Hotel-Café Ritter von Böhl, Deidesheim (oder gleichwertig)',
      '2 x Frühstücksbuffet',
      '2 x Abendmenü im Leopold’s bzw. Hofgut Ruppertsberg',
      '1 x Weingutsführung mit Weinprobe im Bio-Weingut Fitz-Ritter',
      '1 x Rebstock-Patenschaft für 3 Jahre',
      '1 x Gradier-Führung und Salzsieden incl. Wein und Winzervesper',
      '1 x Hofführung und Verkostung bei den Tee-Gärtnern Schönfeld',
      'Transferfahrten',
      'Durchgängige AUSZEIT-Reiseleitung'
    ]
  },
  {
    id: 'wein-kulinarik',
    title: 'Wein&Kulinarik',
    slogan: 'Lernen Sie zu Kochen wie ein Profi',
    shortDescription: 'Lernen Sie zu Kochen wie ein Profi',
    primaryColor: '#43cd7d',
    secondaryColor: '#87918b',
    previewImage: require('./assets/img/wein-kulinarik.jpg'),
    image: require('./assets/img/wein-kulinarik-desktop.jpg'),
    smallImage: require('./assets/img/wein-kulinarik-mobil.jpg'),
    arrivalInfo: `Nach Ihrer individuellen Anreise und dem Check-In im Landhotel Kallstadt am Freitagabend können
    wir uns bei einem gemeinsamen Abendessen im nahegelegenen WEINGUT AM NIL kennenlernen und
    uns auf das bevorstehende AUSZEIT-Wochenende einstimmen.`,
    experienceInfo: `Gut gestärkt nach einem reichhaltigen Frühstück in unserem Landhotel starten wir unser AUSZEIT
    Erlebnis. Entspannt lassen wir uns nach Deidesheim fahren, zum renommierten VDP-WEINGUT
    BASSERMANN-JORDAN, oder gleichwertig. Die Geschichte des Weinguts Geheimer Rat Dr. von Bassermann-Jordan ist die
    Geschichte einer Familiendynastie, die den Qualitätsweinbau mit begründet hat und seit knapp 300
    Jahren maßgeblich beeinflusst. Es erwartet uns eine spannende Kellerführung mit Weinprobe und
    Winzervesper.
    Nach ca. 20 Minuten Fahrt entlang der deutschen Weinstraße erreichen wir das WEINESSIGGUT
    „DOKTORENHOF“ in Venningen. Eingekleidet in lange Kapuzenmäntel tauchen wir ein in die Welt der
    sauren Kunst und betreten im Rahmen einer Führung das „Heiligste“ des Anwesens, den alten
    Essigkeller und die Kräuterkammer. An die Führung schließt sich eine Verkostung diverser Edelessige
    an. Und damit sind wir auch schon eingestimmt auf das nächste Highlight des AUSZEIT-Wochenendes
    – dem eigens für uns zusammengestellten Kochkurs in den Räumen der „GENUSSTUR“ von Matthias
    Mangold. Lassen Sie sich überraschen…
    Mit vielen kreativen Koch-Ideen und gewonnenen Eindrücken im Gepäck lassen wir uns zurück in
    unser Hotel bringen.`,
    departureInfo: `Am Sonntagmorgen steht wieder ein leckeres Frühstück für Sie bereit. Danach treten Sie in Ruhe und
    entspannt Ihre individuelle Heimreise an.`,
    location: 'Kallstadt',
    price: 489,
    singleRoomAdditional: 30,
    coordinates: [8.177380, 49.491340],
    services: [
      'Begrüßungssekt',
      '2 Übernachtungen im Doppelzimmer Hotel-Café Ritter von Böhl, Deidesheim (oder gleichwertig)',
      '2 x Frühstücksbuffet',
      '2 x Abendmenü im Leopold’s bzw. Hofgut Ruppertsberg',
      '1 x Weingutsführung mit Weinprobe im Bio-Weingut Fitz-Ritter',
      '1 x Rebstock-Patenschaft für 3 Jahre',
      '1 x Gradier-Führung und Salzsieden incl. Wein und Winzervesper',
      '1 x Hofführung und Verkostung bei den Tee-Gärtnern Schönfeld',
      'Transferfahrten',
      'Durchgängige AUSZEIT-Reiseleitung'
    ]
  }
];
